import { createContext } from 'react';
export const defaultLabels = {
    release: (count) => (count > 1 ? `Release to add ${count} files` : 'Release to add'),
    uploading: (done, total) => `Uploading ${done} of ${total}`,
    added: (total) => `${total} ${total === 1 ? 'file' : 'files'} added`,
    failed: 'Some uploads failed',
    dropMore: 'Drop more files',
    retry: 'Retry',
    remove: (name) => `Remove ${name}`,
    chooseFiles: (prompt) => `${prompt}. Press Enter to choose files.`,
    status: {
        queued: 'Waiting',
        transferring: 'Uploading',
        processing: 'Processing',
        transcoding: 'Transcoding',
        done: 'Added',
        error: 'Upload failed',
    },
    rejected: (r, count) => count === 1 ? `${r.file.name} skipped · ${r.message}` : `${count} files skipped · ${r.message}`,
    repEarned: (amount) => `+${amount} rep earned`,
};
/**
 * App-wide label layer (usually the active locale), between the English defaults
 * and a call site's own `labels` prop.
 */
export const MediaDropLabelsContext = createContext(undefined);
export const MediaDropLabelsProvider = MediaDropLabelsContext.Provider;
/**
 * App label layer from an i18n `t` scoped to the `common` namespace, whose
 * `media-drop.*` keys every locale catalog carries.
 */
export function localizedLabels(t) {
    const reason = (rejection) => {
        if (rejection.reason === 'custom')
            return rejection.message;
        return t(`media-drop.reason-${rejection.reason}`, { max: rejection.limit ?? 0 });
    };
    const labels = {
        release: (count) => t('media-drop.release', { count }),
        uploading: (done, total) => t('media-drop.uploading', { done, total }),
        added: (count) => t('media-drop.added', { count }),
        failed: t('media-drop.failed'),
        dropMore: t('media-drop.drop-more'),
        retry: t('media-drop.retry'),
        remove: (name) => t('media-drop.remove', { name }),
        chooseFiles: (prompt) => t('media-drop.choose', { prompt }),
        status: {
            queued: t('media-drop.queued'),
            transferring: t('media-drop.transferring'),
            processing: t('media-drop.processing'),
            transcoding: t('media-drop.transcoding'),
            done: t('media-drop.done'),
            error: t('media-drop.error'),
        },
        rejected: (rejection, count) => t('media-drop.rejected', { count, name: rejection.file.name, reason: reason(rejection) }),
        repEarned: (amount) => t('media-drop.rep-earned', { amount }),
    };
    return labels;
}
export function resolveLabels(...layers) {
    return layers.reduce((memo, layer) => (layer ? { ...memo, ...layer, status: { ...memo.status, ...layer.status } } : memo), defaultLabels);
}
//# sourceMappingURL=labels.js.map